package org.hs_soft.runmynesto.pages.home.sub_page.dashboard.component.dashboard_reports

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.dashboard.dashboard_config.ListShopItem
import org.hs_soft.runmynesto.domain.model.home.dashboard.get_shop_statics.ShopStatistic
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.home.sub_page.dashboard.component.DashboardDialogs
import org.hs_soft.runmynesto.pages.home.sub_page.dashboard.component.dashboard_reports.component.DashboardReports
import org.hs_soft.runmynesto.pages.home.sub_page.dashboard.mvi.DashboardEvent
import org.hs_soft.runmynesto.pages.home.sub_page.dashboard.mvi.DashboardState
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection

@Composable
fun DashboardList(
    windowSizeMode: WindowSizeModeEnum,
    state: DashboardState,
    event:(DashboardEvent)->Unit,
) {
    LaunchedEffect(Unit){
        event(DashboardEvent.GetDashboardConfigs)
        event(DashboardEvent.GetShopStatics)
    }

    Column(
        modifier = Modifier
            .scrollBehavior(ScrollBehavior.Smooth)
            .fillMaxHeight()
            .fillMaxWidth()
            .styleModifier {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
            }
    )
    {
        MediumContentTitle(
            title = Strings.current().restaurantsOf
            +" "+state.selectedShop?.name,
            marginBottom = Dimen.largePadding,
        )

        DashboardFilter(
            windowSizeMode = windowSizeMode,
            listShop = state.listShop,
            selectedShopId=state.selectedShop?.id,
            selectedDate = state.selectedDate,
            setCalendarStatus = {
                event(DashboardEvent.SetCalendarStatus(it))
            },
            filterBasedOnRegion = {
                event(DashboardEvent.FilterBasedOnRegion(it))
            }
        )


        DashboardReports(
            modifier= VerticalScrollBehavior.toModifier()
                .weight(1f),
            windowSizeMode = windowSizeMode,
            loading=state.dataLoadingProgressVisible,
            listShop =state.listShop,
            shopStaticsData= if (state.selectedShop == ListShopItem(
                    name = LanguageManager.getCurrentStrings().allTheRegions,
                )) {
                    state.shopStaticsData
                } else {
                    state.shopStaticsData?.
                    filter { it.branchId.toString() == state.selectedShop?.id }
                },
            currencyType = state.currencyType ?: "",
            onItemClick = { item: ShopStatistic, itemName:String->
                event(DashboardEvent.OnDashboardItemClick(
                    item=item,
                    itemName=itemName
                ))
            }
        )


    }

    DashboardDialogs(
        showCalendarDialog = state.showCalendarDialog,
        selectedDate=state.selectedDate,
        calendarData = state.calendarData,
        onSelectDay = {
            event(DashboardEvent.GetShopListItems(it))
        },
        onBackgroundClick = {
            event(DashboardEvent.SetCalendarStatus(false))
        },
        closeCalendarDialog = {
            event(DashboardEvent.SetCalendarStatus(false))
        }
    )

}